import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch } from 'store';
import { LayoutState, toggleSound } from 'store/layoutSlice';

import Button from 'layout/atoms/Button';

import { ReactComponent as SoundOffIcon } from 'assets/icons/sound-off.svg';
import { ReactComponent as SoundOnIcon } from 'assets/icons/sound-on.svg';

const SoundToggle = () => {
    const dispatch = useDispatch<AppDispatch>();
    const layoutState: LayoutState = useSelector((state: any) => state.layout);

    const handleChange = () => {
        const newSound = !layoutState.soundOn;
        localStorage.setItem('hustleSound', newSound ? 'on' : 'off');
        dispatch(toggleSound());
    };

    return (
        <Button size="m" align="left" onClick={handleChange} keepDropdownOpen>
            {layoutState.soundOn ? <SoundOnIcon /> : <SoundOffIcon />}
            <span>Sound: {layoutState.soundOn ? 'on' : 'off'}</span>
        </Button>
    );
};

export default SoundToggle;
